import { $Q } from "graditify-utils";

/**
 * Replace en element with a spinner
 * @param {String} element
 */
export const addSpinner = (element, parent) => {
  $Q(element, parent).innerHTML = '<div class="loading"></div>';
};
